import Cron from './Cron'

export * from './types'

// Support "import { Cron } from 'react-js-cron'"
// Support "import { Cron as ReactJSCron } from 'react-js-cron'"
export { Cron }

// Support "import Cron from 'react-js-cron'"
export default Cron
